/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Playdata_Home_About_HeadingInputs */

const ja_playdata_home_about_heading = /** @type {(inputs: Playdata_Home_About_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PLAYDATAとは？`)
};

const en_playdata_home_about_heading = /** @type {(inputs: Playdata_Home_About_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PLAYDATA Reports make esports and streaming analysis easy`)
};

/**
* | output |
* | --- |
* | "PLAYDATA Reports make esports and streaming analysis easy" |
*
* @param {Playdata_Home_About_HeadingInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const playdata_home_about_heading = /** @type {((inputs?: Playdata_Home_About_HeadingInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playdata_Home_About_HeadingInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_playdata_home_about_heading(inputs)
	return en_playdata_home_about_heading(inputs)
});